import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isTomorrow from 'dayjs/plugin/isTomorrow';
import isYesterday from 'dayjs/plugin/isYesterday';

dayjs.extend(isToday);
dayjs.extend(isTomorrow);
dayjs.extend(isYesterday);

const getEndDateInfo = (endDate) => {
  let endDateText;
  let endDateColor;

  if (dayjs(endDate).isToday()) {
    endDateText = 'Today';
    endDateColor = 'success';
  } else if (dayjs(endDate).isTomorrow()) {
    endDateText = 'Tomorrow';
    endDateColor = 'success';
  } else if (dayjs(endDate).isYesterday()) {
    endDateText = 'Yesterday';
    endDateColor = 'error';
  } else {
    endDateText = dayjs(endDate).format('MMM DD');
    if (new Date(endDate) < new Date()) {
      endDateColor = 'error';
    } else {
      endDateColor = 'inherit';
    }
  }

  return { endDateText, endDateColor };
};

export default getEndDateInfo;
